import { createContext } from 'react';

export const HideMenusContext = createContext<boolean | null>(null);
